
export default function AboutSection() {
  const stats = [
    { number: '500+', label: 'Global Partners' },
    { number: '18+', label: 'Years Experience' },
    { number: '50+', label: 'Countries Served' },
    { number: '1000+', label: 'New Products Developed' },
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Leading Global Supply Chain Solutions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            XJ Global is a leading sourcing, product development and supply chain management company for the world's largest retail chain stores and brands. Beyond working with suppliers, XJ owns multiple factories in China, US, and South Korea to produce certain items, especially in the beauty industry under our{' '}
            <a 
              href="https://www.xj-beauty.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer"
            >
              XJ BEAUTY
            </a>{' '}
            business division.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-teal-600 mb-2">
                {stat.number}
              </div>
              <div className="text-gray-600 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
              Your Trusted Global Partner
            </h3>
            <p className="text-gray-600 mb-6 text-lg">
              We specialize in connecting businesses with reliable suppliers and manufacturers worldwide, ensuring quality products at competitive prices with efficient supply chain management.
            </p>
            <div className="space-y-4">
              <div className="flex items-start">
                <div className="w-6 h-6 flex items-center justify-center mt-1">
                  <i className="ri-check-line text-teal-600 text-xl"></i>
                </div>
                <div className="ml-3">
                  <h4 className="font-semibold text-gray-900">Global Sourcing Network</h4>
                  <p className="text-gray-600">Access to verified suppliers across 50+ countries</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-6 h-6 flex items-center justify-center mt-1">
                  <i className="ri-check-line text-teal-600 text-xl"></i>
                </div>
                <div className="ml-3">
                  <h4 className="font-semibold text-gray-900">Quality Assurance</h4>
                  <p className="text-gray-600">Rigorous quality control and inspection processes</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-6 h-6 flex items-center justify-center mt-1">
                  <i className="ri-check-line text-teal-600 text-xl"></i>
                </div>
                <div className="ml-3">
                  <h4 className="font-semibold text-gray-900">End-to-End Solutions</h4>
                  <p className="text-gray-600">From product development to delivery logistics</p>
                </div>
              </div>
            </div>
          </div>
          <div className="relative">
            <img
              src="https://images.squarespace-cdn.com/content/v1/664c7ad1bcc10d55948aedd4/665444ac-f4f9-4458-b8b3-1afde0e4ccc6/page2.jpg"
              alt="Modern office workspace"
              className="rounded-lg shadow-lg w-full h-auto object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
